import * as action from '../../actions/gdprAdsV3/advertisingOptionsActions';
import saveEmailAdsSelectOptionsOrchestrator from '../../orchestrators/gdprAdsV3/saveEmailAdsSelectOptionsOrchestrator';
import { getOptionsStore } from '../../store/Store';
import { orchestrator } from 'satcheljs';
import { setEmailadsOptInBit } from 'owa-emailadsoptin-store';

const setEmailAdsSelectOptionsOrchestrator = orchestrator(
    action.setEmailAdsSelectOptions,
    actionMessage => {
        const store = getOptionsStore();

        // 1 is explicitly opt-off
        // 2 is explicitly opt-in
        // no value or 0 is implicitly off. User has not made the selections before.
        setEmailadsOptInBit(actionMessage.optInBit);

        saveEmailAdsSelectOptionsOrchestrator(store);
    }
);

export default setEmailAdsSelectOptionsOrchestrator;
